export interface VideoItem {
  id: string;
  title: string;
  category: string;
  coverImage: string;
  description: string;
  duration: string;
  year: number;
  rating: number;
  tags: string[];
  views: number;
  updateDate: string;
  director: string;
  actors: string[];
  region: string;
  language: string;
  episodeInfo: string;
  contentHtml: string;
  relatedVideos: string[];
}

export const videos: VideoItem[] = [
  {
    id: "v001",
    title: "流浪地球3",
    category: "科幻大片",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20earth%20in%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20orange%20and%20dark%20blue%20tones%2C%20movie%20poster%20style%20with%20Chinese%20text%20area%2C%20clean%20minimal%20background&width=400&height=560&seq=v001-cover&orientation=portrait",
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。",
    duration: "148分钟",
    year: 2025,
    rating: 9.2,
    tags: ["科幻", "灾难", "冒险", "国产"],
    views: 2580000,
    updateDate: "2026-07-28",
    director: "郭帆",
    actors: ["吴京", "刘德华", "李雪健", "沙溢"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "HD1080P·国语中字",
    contentHtml: "<p>《流浪地球3》是由郭帆执导，吴京、刘德华、李雪健、沙溢等主演的科幻灾难电影。该片是《流浪地球》系列的第三部作品，延续了前作的宏大世界观和震撼视觉效果。</p><p>影片讲述了太阳急速衰老膨胀，整个太阳系都将被太阳所吞没。为了自救，人类提出一个名为\"流浪地球\"的大胆计划，即倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，奔向4.2光年外的新家园。</p><p>本片在视觉效果上达到了国产科幻电影的新高度，太空场景的渲染精度和物理模拟均达到了国际一流水准。影片不仅展现了中国式的家园情怀，更深入探讨了人类在面对生存危机时的抉择与坚守。</p>",
    relatedVideos: ["v004", "v007", "v012"]
  },
  {
    id: "v002",
    title: "繁花",
    category: "热播剧集",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20drama%20series%20poster%20set%20in%201990s%20Shanghai%2C%20vintage%20aesthetic%2C%20warm%20golden%20lighting%2C%20elegant%20composition%2C%20nostalgic%20mood%2C%20Chinese%20drama%20poster%20style%2C%20clean%20background&width=400&height=560&seq=v002-cover&orientation=portrait",
    description: "九十年代的上海处处是机遇与希望。青年阿宝凭借改革开放的春风和自己的打拼，跻身成为商界后起之秀。黄河路上人来人往，潮起潮落，谱写了一段传奇故事。",
    duration: "30集全",
    year: 2024,
    rating: 9.5,
    tags: ["剧情", "都市", "年代", "商战"],
    views: 5120000,
    updateDate: "2026-07-30",
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    region: "中国大陆",
    language: "汉语普通话/沪语",
    episodeInfo: "4K·沪语/国语双音轨",
    contentHtml: "<p>《繁花》是由王家卫执导并监制，胡歌、马伊琍、唐嫣、辛芷蕾等主演的都市情感剧。该剧改编自金宇澄同名小说，讲述了20世纪90年代初的上海，青年阿宝凭借改革开放的春风，从默默无闻到成为商界翘楚的传奇故事。</p><p>剧中以独特的双语言版本呈现——普通话版和沪语版，开创了国产电视剧的先河。王家卫导演标志性的影像风格在剧中得到了充分展现，光影的运用和画面的构图都达到了电影级别的质感。</p><p>作为2024年最具话题性的国产剧集，《繁花》不仅还原了90年代上海的时代风貌，更深入刻画了那个特殊年代里普通人的命运沉浮与情感纠葛。</p>",
    relatedVideos: ["v008", "v015", "v020"]
  },
  {
    id: "v003",
    title: "周处除三害",
    category: "动作大片",
    coverImage: "https://readdy.ai/api/search-image?query=Taiwanese%20action%20crime%20movie%20poster%20with%20intense%20expression%2C%20dark%20moody%20lighting%2C%20red%20and%20black%20color%20scheme%2C%20cinematic%20poster%20style%2C%20thriller%20atmosphere%2C%20clean%20minimal%20background&width=400&height=560&seq=v003-cover&orientation=portrait",
    description: "通缉犯陈桂林在生命将尽之际，发现自己在通缉榜上只排名第三。为了扬名立万，他决心找出前两名通缉犯的下落，并将他们一一除掉，上演了一出当代版的\"周处除三害\"。",
    duration: "134分钟",
    year: 2023,
    rating: 8.8,
    tags: ["动作", "犯罪", "剧情", "台片"],
    views: 1860000,
    updateDate: "2026-07-15",
    director: "黄精甫",
    actors: ["阮经天", "袁富华", "陈以文", "王净"],
    region: "中国台湾",
    language: "汉语普通话/闽南语",
    episodeInfo: "HD1080P·国语中字",
    contentHtml: "<p>《周处除三害》是一部由黄精甫执导，阮经天主演的中国台湾动作犯罪电影。影片借用《晋书·周处传》和《世说新语》中\"周处除三害\"的典故，讲述了通缉犯陈桂林在生命尽头之际，决心除去通缉榜上排在自己前面的两名罪犯的故事。</p><p>影片以其独特的黑色幽默风格和紧凑的叙事节奏获得了观众和评论界的一致好评。阮经天在片中的表演被赞为\"脱胎换骨\"，成功塑造了一个复杂而立体的反派角色。</p><p>该片在第60届金马奖上获得了最佳男主角、最佳动作设计等多项大奖，成为2023年度最具话题性的华语电影之一。</p>",
    relatedVideos: ["v006", "v011", "v018"]
  },
  {
    id: "v004",
    title: "三体",
    category: "科幻大片",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20three%20body%20problem%2C%20cosmic%20mystery%2C%20dark%20space%20background%20with%20stars%2C%20mysterious%20atmosphere%2C%20cinematic%20poster%20style%2C%20cool%20tone%2C%20clean%20composition&width=400&height=560&seq=v004-cover&orientation=portrait",
    description: "纳米科学家汪淼在警官史强的帮助下，揭开了地外文明\"三体\"世界的神秘面纱，并随之展开了一场全人类共同参与的博弈与抗争。",
    duration: "30集全",
    year: 2024,
    rating: 8.9,
    tags: ["科幻", "悬疑", "剧情", "国产"],
    views: 4350000,
    updateDate: "2026-07-25",
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "4K杜比视界·国语中字",
    contentHtml: "<p>《三体》是由杨磊执导，张鲁一、于和伟、陈瑾、王子文等主演的科幻剧集，改编自刘慈欣同名科幻小说。该剧讲述了地球基础科学研究遭遇异常扰动，引发科学界惶恐与动荡的故事。</p><p>纳米物理学家汪淼与刑警史强联手调查，共同揭开了地外未知文明\"三体\"世界的神秘面纱。剧集在保持原著科幻内核的同时，对人物关系和情感线进行了合理拓展，使故事更加丰满动人。</p><p>该剧在视觉效果上投入巨大，三体游戏世界中的\"脱水\"\"浸泡\"等经典场景以惊人的视觉效果呈现，为观众带来了前所未有的国产科幻观剧体验。</p>",
    relatedVideos: ["v001", "v007", "v019"]
  },
  {
    id: "v005",
    title: "封神第二部",
    category: "奇幻巨制",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20mythology%20fantasy%20movie%20poster%20with%20ancient%20Chinese%20warriors%20and%20mythical%20creatures%2C%20epic%20battle%20scene%2C%20golden%20and%20crimson%20tones%2C%20cinematic%20poster%20style%2C%20dramatic%20composition&width=400&height=560&seq=v005-cover&orientation=portrait",
    description: "殷商末年，纣王暴虐无道。姬发在姜子牙等昆仑仙人的帮助下，率领西岐军民奋起反抗，一场神魔大战即将全面爆发。",
    duration: "156分钟",
    year: 2025,
    rating: 8.7,
    tags: ["奇幻", "古装", "神话", "动作"],
    views: 3200000,
    updateDate: "2026-07-20",
    director: "乌尔善",
    actors: ["费翔", "黄渤", "于适", "陈牧驰"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "IMAX版·国语中字",
    contentHtml: "<p>《封神第二部》是乌尔善执导的神话史诗电影系列的第二部作品，延续第一部的宏大叙事，讲述了姬发在姜子牙等昆仑仙人的帮助下，率领西岐军民奋起反抗商纣王的故事。</p><p>影片在神话元素和视觉呈现上进一步升级，众多神魔角色的登场和法术特效的呈现为观众带来了震撼的视听享受。战斗场面的调度和特效制作均达到了华语电影的顶级水准。</p><p>作为\"封神三部曲\"的承上启下之作，本片在人物塑造和世界观拓展上做出了重要贡献，为第三部的终极决战奠定了坚实的基础。</p>",
    relatedVideos: ["v009", "v014", "v016"]
  },
  {
    id: "v006",
    title: "九龙城寨之围城",
    category: "动作大片",
    coverImage: "https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20movie%20poster%20Kowloon%20Walled%20City%2C%20dark%20alley%20neon%20lights%2C%20gritty%20urban%20atmosphere%2C%20martial%20arts%20theme%2C%20cinematic%20poster%20style%2C%20moody%20lighting&width=400&height=560&seq=v006-cover&orientation=portrait",
    description: "八十年代香港，落难青年陈洛军误闯九龙城寨，被城寨传奇人物龙卷风所救。在这个三不管地带中，一场关于生存与复仇的故事就此展开。",
    duration: "128分钟",
    year: 2024,
    rating: 8.5,
    tags: ["动作", "犯罪", "港片", "剧情"],
    views: 1980000,
    updateDate: "2026-07-18",
    director: "郑保瑞",
    actors: ["古天乐", "洪金宝", "任贤齐", "林峯"],
    region: "中国香港",
    language: "粤语/汉语普通话",
    episodeInfo: "HD1080P·粤语/国语双音轨",
    contentHtml: "<p>《九龙城寨之围城》是由郑保瑞执导，古天乐、洪金宝、任贤齐、林峯等主演的香港动作犯罪电影。影片以香港历史上真实存在的九龙城寨为背景，讲述了一段波澜壮阔的江湖传奇。</p><p>影片在美术设计上真实还原了九龙城寨的独特风貌——密集的建筑、交错的巷道和昏暗的灯光，为观众营造了一个真实可信的叙事空间。动作设计融合了传统武术和现代格斗元素，打斗场面硬核且富有美感。</p><p>该片在上映后获得了广泛好评，被认为是近年来最优秀的港产动作片之一，也是对已经消失的九龙城寨这一独特城市景观的深情致敬。</p>",
    relatedVideos: ["v003", "v011", "v018"]
  },
  {
    id: "v007",
    title: "奥本海默",
    category: "科幻大片",
    coverImage: "https://readdy.ai/api/search-image?query=Hollywood%20biographical%20thriller%20movie%20poster%20with%20nuclear%20explosion%20silhouette%2C%20intense%20portrait%2C%20dark%20dramatic%20lighting%2C%20cinematic%20poster%20style%2C%20orange%20and%20black%20tones&width=400&height=560&seq=v007-cover&orientation=portrait",
    description: "克里斯托弗·诺兰自编自导的传记电影，讲述了\"原子弹之父\"罗伯特·奥本海默在曼哈顿计划中的故事，以及他在战后遭受政治迫害的经历。",
    duration: "180分钟",
    year: 2023,
    rating: 9.3,
    tags: ["传记", "历史", "剧情", "战争"],
    views: 1680000,
    updateDate: "2026-07-22",
    director: "克里斯托弗·诺兰",
    actors: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙", "小罗伯特·唐尼"],
    region: "美国/英国",
    language: "英语",
    episodeInfo: "IMAX版·英语中字",
    contentHtml: "<p>《奥本海默》是一部由克里斯托弗·诺兰编剧并执导的史诗传记惊悚片，改编自卡伊·伯德和马丁·J·舍温所著传记《美国普罗米修斯：罗伯特·奥本海默的胜利与悲剧》。</p><p>影片聚焦于\"原子弹之父\"罗伯特·奥本海默的一生——他在曼哈顿计划中领导洛斯阿拉莫斯实验室，成功研制出世界上第一颗原子弹，以及随后他因政治立场而遭受的迫害与审查。</p><p>诺兰以其标志性的非线性叙事结构，将彩色和黑白两种影像分别用于呈现奥本海默的主观视角和客观视角，创造了一种独特的观影体验。该片在第96届奥斯卡金像奖上获得了最佳影片、最佳导演等多项大奖。</p>",
    relatedVideos: ["v001", "v004", "v012"]
  },
  {
    id: "v008",
    title: "庆余年第二季",
    category: "热播剧集",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20Chinese%20palace%20setting%2C%20elegant%20costume%2C%20warm%20golden%20lighting%2C%20cinematic%20poster%20style%2C%20dramatic%20composition%2C%20clean%20background&width=400&height=560&seq=v008-cover&orientation=portrait",
    description: "范闲在经历了一系列风波后，回到京都继续他的仕途。朝堂之上暗流涌动，江湖之中危机四伏。范闲将如何在这复杂的局势中生存并寻找真相？",
    duration: "36集全",
    year: 2024,
    rating: 9.1,
    tags: ["古装", "权谋", "喜剧", "武侠"],
    views: 6800000,
    updateDate: "2026-08-01",
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "4K·国语中字",
    contentHtml: "<p>《庆余年第二季》延续第一季的故事，范闲率领使团回归途中，二皇子以费介、范思辙以及滕家遗孤的安危来威胁范闲，逼他向自己俯首称臣，二人的矛盾就此激发。范闲所面对的抱月楼迷局，以及接踵而至的春闱危机，都是二皇子精心给范闲布下的陷阱。</p><p>范闲与林婉儿如愿大婚，接手内库后却发现内库负债累累。范闲拒绝了庆余堂大掌柜的相助，决定靠自己的力量解决内库危机。范闲与城中众商贾相聚苍山，以售卖\"库债\"为机筹集了两千多万银两，解决了内库空虚问题。</p><p>悬空寺上，庆帝遭遇三连刺杀，范闲出手相救却导致武功全废。危机四伏，压力陡增，范闲别无选择，他必须以这样的身体下江南，挑战庞大的势力与既定的游戏规则，以求彻底夺回内库。</p>",
    relatedVideos: ["v002", "v015", "v020"]
  },
  {
    id: "v009",
    title: "哪吒之魔童闹海",
    category: "奇幻巨制",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20mythological%20young%20hero%20character%2C%20fire%20and%20water%20elements%2C%20vibrant%20colors%2C%20dynamic%20composition%2C%20cinematic%20animation%20poster%20style%2C%20epic%20fantasy&width=400&height=560&seq=v009-cover&orientation=portrait",
    description: "天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，然而在重塑的过程中却遇到了重重困难与挑战。",
    duration: "144分钟",
    year: 2025,
    rating: 9.4,
    tags: ["动画", "奇幻", "神话", "喜剧"],
    views: 8900000,
    updateDate: "2026-08-01",
    director: "饺子",
    actors: ["吕艳婷", "瀚墨", "陈浩", "绿绮"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "IMAX 3D版·国语中字",
    contentHtml: "<p>《哪吒之魔童闹海》是《哪吒之魔童降世》的续作，由饺子执导的国产3D动画电影。影片讲述了天劫之后，哪吒和敖丙的灵魂虽然保住，但肉身很快会魂飞魄散的故事。</p><p>太乙真人打算用七色宝莲给二人重塑肉身，但在重塑肉身的过程中却遇到了重重困难。哪吒与敖丙的命运将走向何方？一场更加宏大的冒险即将展开。</p><p>影片在视觉效果和动作设计上进一步突破，将中国传统神话元素与现代动画技术完美结合，为观众呈现了一个绚丽多彩的东方奇幻世界。</p>",
    relatedVideos: ["v005", "v014", "v016"]
  },
  {
    id: "v010",
    title: "我的阿勒泰",
    category: "高分佳作",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20with%20vast%20grassland%20landscape%20in%20Xinjiang%2C%20warm%20sunset%20lighting%2C%20nomadic%20lifestyle%2C%20peaceful%20atmosphere%2C%20cinematic%20poster%20style%2C%20natural%20colors%2C%20clean%20composition&width=400&height=560&seq=v010-cover&orientation=portrait",
    description: "生长在阿勒泰的汉族少女李文秀，一心想在大城市追求文学梦想，却屡屡碰壁。回到家乡后，她在母亲和牧民的相处中发现了生活之美与创作之源。",
    duration: "8集全",
    year: 2024,
    rating: 9.3,
    tags: ["剧情", "文艺", "家庭", "治愈"],
    views: 1450000,
    updateDate: "2026-07-12",
    director: "滕丛丛",
    actors: ["马伊琍", "周依然", "于适", "蒋奇明"],
    region: "中国大陆",
    language: "汉语普通话/哈萨克语",
    episodeInfo: "4K·国语中字",
    contentHtml: "<p>《我的阿勒泰》是由滕丛丛执导，马伊琍、周依然、于适等主演的治愈系剧集。该剧改编自李娟的同名散文集，以新疆阿勒泰地区为背景，讲述了汉族少女李文秀的成长故事。</p><p>李文秀在大城市追求文学梦想的过程中屡屡受挫，被迫回到家乡阿勒泰。在与开小卖部的母亲以及当地哈萨克族牧民的相处中，她逐渐发现了生活之美和创作的原动力。</p><p>该剧以诗意的镜头语言展现了阿勒泰壮美的自然风光和淳朴的民风民俗，被誉为\"国产剧中的一股清流\"。其舒缓的叙事节奏和温暖治愈的故事内核，在快节奏的时代中为观众提供了一方宁静的精神栖息地。</p>",
    relatedVideos: ["v017", "v020", "v013"]
  },
  {
    id: "v011",
    title: "速度与激情10",
    category: "动作大片",
    coverImage: "https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20fast%20cars%20and%20explosion%2C%20urban%20street%20racing%20theme%2C%20dynamic%20composition%2C%20cinematic%20poster%20style%2C%20orange%20and%20dark%20tones&width=400&height=560&seq=v011-cover&orientation=portrait",
    description: "在无数次危险任务中，唐老大和他的家人们凭借着智慧和勇气克服了所有对手。但当他们面对一名有着致命过往的敌人时，一切都将面临前所未有的考验。",
    duration: "141分钟",
    year: 2023,
    rating: 7.8,
    tags: ["动作", "犯罪", "冒险", "赛车"],
    views: 1250000,
    updateDate: "2026-07-05",
    director: "路易斯·莱特里尔",
    actors: ["范·迪塞尔", "杰森·斯坦森", "米歇尔·罗德里格兹", "杰森·莫玛"],
    region: "美国",
    language: "英语",
    episodeInfo: "IMAX版·英语中字",
    contentHtml: "<p>《速度与激情10》是《速度与激情》系列电影的第十部主线作品，由路易斯·莱特里尔执导。影片延续了系列一贯的高燃动作风格，并引入了新的反派角色但丁（杰森·莫玛 饰）。</p><p>但丁是当年在巴西被唐老大打败的毒枭赫曼·雷耶斯的儿子，他花了十二年时间精心策划了一场针对唐老大及其家人的复仇计划。唐老大必须面对这个前所未有的强大敌人，保护自己所珍视的一切。</p><p>影片在全球多地取景拍摄，包括罗马、里约热内卢、伦敦等城市，为观众呈现了震撼的视觉场面和惊险的飞车特技。</p>",
    relatedVideos: ["v003", "v006", "v018"]
  },
  {
    id: "v012",
    title: "沙丘2",
    category: "科幻大片",
    coverImage: "https://readdy.ai/api/search-image?query=Hollywood%20sci-fi%20movie%20poster%20with%20desert%20planet%20landscape%20and%20giant%20sandworms%2C%20epic%20scale%2C%20warm%20sand%20tones%2C%20cinematic%20poster%20style%2C%20dramatic%20composition&width=400&height=560&seq=v012-cover&orientation=portrait",
    description: "保罗·厄崔迪与契妮和弗雷曼人联手，踏上了对毁灭他家族的阴谋者的复仇之路。面对一生挚爱与已知宇宙命运之间的抉择，他必须努力阻止只有他能预见的可怕未来。",
    duration: "166分钟",
    year: 2024,
    rating: 9.0,
    tags: ["科幻", "冒险", "剧情", "史诗"],
    views: 2100000,
    updateDate: "2026-07-08",
    director: "丹尼斯·维伦纽瓦",
    actors: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森", "奥斯汀·巴特勒"],
    region: "美国/加拿大",
    language: "英语",
    episodeInfo: "IMAX版·英语中字",
    contentHtml: "<p>《沙丘2》是由丹尼斯·维伦纽瓦执导的史诗科幻电影，改编自弗兰克·赫伯特的经典科幻小说《沙丘》的后半部分。影片延续了第一部的故事线，讲述了保罗·厄崔迪与弗雷曼人并肩作战的传奇经历。</p><p>保罗·厄崔迪在沙漠星球厄拉科斯上与弗雷曼人一同生活，并逐渐成长为他们的领袖。他与契妮之间的感情日益深厚，同时也在为家族复仇的道路上不断前行。然而，他的崛起也带来了预知未来的能力，让他看到了一个可怕的命运。</p><p>影片在视觉呈现上再次突破，沙漠场景的拍摄和沙虫的CGI呈现都达到了令人叹为观止的水准。汉斯·季默的配乐更是为这个宏大的史诗故事增添了强烈的情感张力。</p>",
    relatedVideos: ["v001", "v004", "v007"]
  },
  {
    id: "v013",
    title: "宇宙探索编辑部",
    category: "高分佳作",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20mockumentary%20comedy%20movie%20poster%20with%20retro%20sci-fi%20elements%2C%20quirky%20aesthetic%2C%20warm%20vintage%20tones%2C%20cinematic%20poster%20style%2C%20clean%20minimal%20background&width=400&height=560&seq=v013-cover&orientation=portrait",
    description: "科幻杂志《宇宙探索》编辑部的主编唐志军，是一个痴迷于寻找外星文明的\"民科\"。当杂志社面临倒闭时，他意外收到了一个疑似来自宇宙的异常信号，于是召集伙伴们踏上了寻找外星人的荒诞之旅。",
    duration: "118分钟",
    year: 2023,
    rating: 8.6,
    tags: ["喜剧", "科幻", "伪纪录片", "文艺"],
    views: 890000,
    updateDate: "2026-06-28",
    director: "孔大山",
    actors: ["杨皓宇", "艾丽娅", "王一通", "蒋奇明"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "HD1080P·国语中字",
    contentHtml: "<p>《宇宙探索编辑部》是一部由孔大山执导的伪纪录片式科幻喜剧电影。影片采用了独特的伪纪录片叙事形式，讲述了科幻杂志《宇宙探索》编辑部主编唐志军寻找外星文明的荒诞故事。</p><p>唐志军是一个执着的\"民科\"，他几十年如一日地坚持寻找外星文明的踪迹。当杂志社面临倒闭之际，他意外接收到一个神秘信号，于是带着一群性格各异的伙伴踏上了寻找之旅。</p><p>影片以幽默诙谐的方式探讨了理想与现实、科学与信仰之间的关系。其独特的叙事风格和深刻的人文关怀使其在影迷群体中获得了极高的评价，被誉为\"中国科幻电影的另一条路\"。</p>",
    relatedVideos: ["v010", "v017", "v020"]
  },
  {
    id: "v014",
    title: "长安三万里",
    category: "奇幻巨制",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20ancient%20Tang%20Dynasty%20setting%2C%20poetic%20atmosphere%2C%20traditional%20Chinese%20painting%20style%2C%20warm%20golden%20tones%2C%20cinematic%20poster%20style%2C%20elegant%20composition&width=400&height=560&seq=v014-cover&orientation=portrait",
    description: "安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军太监回忆起自己与李白的一生往事。",
    duration: "168分钟",
    year: 2023,
    rating: 8.9,
    tags: ["动画", "历史", "文艺", "传记"],
    views: 2750000,
    updateDate: "2026-06-20",
    director: "谢君伟/邹靖",
    actors: ["杨天翔", "凌振赫", "吴俊全", "宣晓鸣"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "HD1080P·国语中字",
    contentHtml: "<p>《长安三万里》是一部由追光动画制作的国产动画电影，以唐代诗人高适的视角，回顾了他与李白跨越数十年的深厚友谊。影片以安史之乱后的困守孤城为叙事框架，以倒叙手法展现了大唐盛世的辉煌与衰落。</p><p>影片中出现了大量经典的唐诗名篇，如《将进酒》《静夜思》《早发白帝城》等，通过精彩的动画演绎让观众感受到了诗歌的无穷魅力。影片的美术风格融入了中国传统水墨画的元素，画面精美绝伦。</p><p>该片不仅是追光动画成立十周年的里程碑之作，也是国产动画在历史题材领域的一次重要突破。它将中国传统文化与现代动画技术完美结合，为观众呈现了一部既有文化底蕴又有视听享受的佳作。</p>",
    relatedVideos: ["v005", "v009", "v016"]
  },
  {
    id: "v015",
    title: "狂飙",
    category: "热播剧集",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20police%20and%20gangster%20duality%2C%20dark%20urban%20setting%2C%20intense%20mood%2C%20cinematic%20poster%20style%2C%20contrast%20lighting%2C%20dramatic%20composition&width=400&height=560&seq=v015-cover&orientation=portrait",
    description: "京海市一线刑警安欣在与黑恶势力的斗争中，屡次遭到保护伞的打击，始终无法将犯罪分子绳之以法。在全国政法队伍教育整顿工作开展后，安欣协同专案组彻查强盛集团犯罪团伙及其背后的保护伞。",
    duration: "39集全",
    year: 2023,
    rating: 9.6,
    tags: ["剧情", "犯罪", "扫黑", "国产"],
    views: 12500000,
    updateDate: "2026-08-01",
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "4K·国语中字",
    contentHtml: "<p>《狂飙》是由徐纪周执导，张译、张颂文、李一桐、张志坚等主演的扫黑除恶题材电视剧。该剧讲述了以一线刑警安欣为代表的正义力量，与黑恶势力进行长达二十年斗争的故事。</p><p>剧中通过群像叙事的方式，展现了扫黑过程中的惊心动魄和黑白较量。张颂文饰演的高启强从一个普通鱼贩蜕变为黑社会头目的角色弧光，成为了2023年最受观众讨论的角色之一。</p><p>该剧在播出后引发了全民追剧热潮，成为现象级爆款剧集。其对扫黑除恶斗争的深入刻画和对人性的深刻剖析，使其不仅是一部精彩的犯罪剧，更是一部具有深刻社会意义的现实主义力作。</p>",
    relatedVideos: ["v002", "v008", "v020"]
  },
  {
    id: "v016",
    title: "深海",
    category: "奇幻巨制",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20deep%20ocean%20fantasy%20world%2C%20colorful%20underwater%20scene%2C%20dreamlike%20atmosphere%2C%20vibrant%20colors%2C%20cinematic%20poster%20style%2C%20magical%20composition&width=400&height=560&seq=v016-cover&orientation=portrait",
    description: "在大海的最深处，藏着所有秘密。一位现代少女参宿误入梦幻的深海世界，却因此邂逅了一段独特的生命旅程。",
    duration: "112分钟",
    year: 2023,
    rating: 8.3,
    tags: ["动画", "奇幻", "冒险", "治愈"],
    views: 1680000,
    updateDate: "2026-06-15",
    director: "田晓鹏",
    actors: ["苏鑫", "王亭文", "滕奎兴", "杨婷"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "HD1080P·国语中字",
    contentHtml: "<p>《深海》是由田晓鹏执导的国产3D动画电影，以其独特的\"水墨粒子\"视觉风格在国产动画中独树一帜。影片讲述了一个名叫参宿的少女在深海世界的奇幻冒险故事。</p><p>参宿是一个内心孤独的现代女孩，她在一次意外中坠入了一个绚丽多彩的深海世界。在这里，她遇到了形形色色的海洋生物，经历了一系列奇幻的冒险，也在旅途中逐渐解开了自己内心深处的秘密。</p><p>影片最大的亮点在于其独创的\"水墨粒子\"动画技术，将中国传统水墨画的意境与现代3D动画技术完美融合，创造出了一个前所未有的视觉奇观。这种独特的视觉风格使《深海》成为了一部具有开创性意义的国产动画作品。</p>",
    relatedVideos: ["v005", "v009", "v014"]
  },
  {
    id: "v017",
    title: "漫长的季节",
    category: "高分佳作",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20suspense%20drama%20poster%20with%20northeastern%20China%20industrial%20setting%2C%20nostalgic%201990s%20aesthetic%2C%20mystery%20atmosphere%2C%20cinematic%20poster%20style%2C%20warm%20vintage%20tones&width=400&height=560&seq=v017-cover&orientation=portrait",
    description: "小城桦林，出租车司机王响做梦也没有想到，他还有机会遇到一个此生最想遇到却又最怕遇到的人。遇到那个人后，王響终于可以问出那个困扰了他十八年的问题。",
    duration: "12集全",
    year: 2023,
    rating: 9.5,
    tags: ["悬疑", "剧情", "家庭", "犯罪"],
    views: 3200000,
    updateDate: "2026-07-10",
    director: "辛爽",
    actors: ["范伟", "秦昊", "陈明昊", "李庚希"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "4K·国语中字",
    contentHtml: "<p>《漫长的季节》是由辛爽执导，范伟、秦昊、陈明昊等主演的悬疑剧集。该剧以1990年代的东北小城桦林为背景，讲述了出租车司机王响、龚彪与退休警官马德胜三人寻找一个跨越十八年的真相的故事。</p><p>故事在1997年、1998年和2016年三条时间线之间自由穿梭，通过精妙的叙事结构将一桩陈年旧案层层剥开。范伟饰演的王响用东北人特有的幽默和坚韧，为这个沉重的故事增添了独特的温度。</p><p>该剧被誉为\"东北文艺复兴\"的代表作之一，其对东北工业城市在时代变迁中的命运进行了深刻而温情的书写。导演辛爽继《隐秘的角落》之后再次奉献了一部高水准的悬疑力作。</p>",
    relatedVideos: ["v010", "v013", "v020"]
  },
  {
    id: "v018",
    title: "疾速追杀4",
    category: "动作大片",
    coverImage: "https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20lone%20assassin%20and%20weapons%2C%20dark%20moody%20lighting%2C%20urban%20night%20setting%2C%20cinematic%20poster%20style%2C%20intense%20atmosphere%2C%20black%20and%20red%20tones&width=400&height=560&seq=v018-cover&orientation=portrait",
    description: "约翰·威克发现了击败高桌会的一条路径，但在获得自由之前，他必须面对一个新的敌人——一个拥有遍布全球的强大联盟、将老朋友变成敌人的强大势力。",
    duration: "169分钟",
    year: 2023,
    rating: 8.5,
    tags: ["动作", "犯罪", "惊悚", "枪战"],
    views: 1350000,
    updateDate: "2026-06-25",
    director: "查德·斯塔赫斯基",
    actors: ["基努·里维斯", "甄子丹", "比尔·斯卡斯加德", "劳伦斯·菲什伯恩"],
    region: "美国",
    language: "英语",
    episodeInfo: "IMAX版·英语中字",
    contentHtml: "<p>《疾速追杀4》是约翰·威克系列的第四部作品，由查德·斯塔赫斯基继续执导，基努·里维斯回归饰演传奇杀手约翰·威克。本作中加入了中国功夫巨星甄子丹饰演的盲人杀手凯恩，为系列增添了全新的动作元素。</p><p>约翰·威克在上一部中正式向高桌会宣战后，成为了整个杀手世界的追杀目标。为了获得真正的自由，他必须走遍全球，击败高桌会派出的各路杀手，并在最后面对侯爵的终极对决。</p><p>影片的动作场面在规模和创意上都达到了系列的巅峰，巴黎街头的长镜头枪战、大阪大陆酒店的武士刀对决以及凯旋门的飞车枪战等场景，都成为了动作电影的经典段落。</p>",
    relatedVideos: ["v003", "v006", "v011"]
  },
  {
    id: "v019",
    title: "异形：夺命舰",
    category: "科幻大片",
    coverImage: "https://readdy.ai/api/search-image?query=Hollywood%20sci-fi%20horror%20movie%20poster%20with%20alien%20creature%20in%20space%20station%2C%20dark%20claustrophobic%20atmosphere%2C%20cinematic%20poster%20style%2C%20cold%20blue%20and%20black%20tones%2C%20suspenseful%20composition&width=400&height=560&seq=v019-cover&orientation=portrait",
    description: "一群年轻而勇敢的太空殖民者，在一座废弃的空间站深处，发现了宇宙中最可怕的生命形式。他们必须在这个幽闭恐怖的环境中，与一种完美的杀戮机器展开殊死搏斗。",
    duration: "119分钟",
    year: 2024,
    rating: 8.0,
    tags: ["科幻", "恐怖", "惊悚", "太空"],
    views: 1580000,
    updateDate: "2026-07-01",
    director: "费德·阿尔瓦雷兹",
    actors: ["卡莉·史派妮", "伊莎贝拉·默塞德", "大卫·琼森", "阿奇·雷诺"],
    region: "美国/英国",
    language: "英语",
    episodeInfo: "IMAX版·英语中字",
    contentHtml: "<p>《异形：夺命舰》是《异形》系列的第七部作品，由费德·阿尔瓦雷兹执导。影片的故事发生在《异形》（1979年）和《异形2》（1986年）之间，讲述了一群年轻的太空殖民者的恐怖遭遇。</p><p>一群年轻人在废弃的太空站中寻找可以带走的设备，却意外唤醒了沉睡多年的异形。在这个封闭且幽暗的环境中，他们必须依靠自己的智慧和勇气，才能在这场不对等的猎杀中幸存下来。</p><p>影片回归了《异形》系列最初的恐怖风格，以幽闭空间的紧张感和对未知生物的恐惧为核心，同时运用了最新的特效技术，为经典系列注入了新的活力。 </p>",
    relatedVideos: ["v001", "v004", "v007"]
  },
  {
    id: "v020",
    title: "去有风的地方",
    category: "高分佳作",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20healing%20drama%20poster%20with%20Yunnan%20countryside%20landscape%2C%20warm%20sunlight%2C%20peaceful%20rural%20setting%2C%20cinematic%20poster%20style%2C%20natural%20colors%2C%20clean%20composition&width=400&height=560&seq=v020-cover&orientation=portrait",
    description: "许红豆因为闺蜜去世而陷入低谷，独自前往大理云苗村的\"有风小院\"休息调整。在那里，她遇到了辞去高薪工作回乡创业的当地人谢之遥，两人在相处中逐渐被彼此吸引。",
    duration: "40集全",
    year: 2023,
    rating: 9.0,
    tags: ["爱情", "治愈", "田园", "剧情"],
    views: 4800000,
    updateDate: "2026-07-15",
    director: "丁梓光",
    actors: ["刘亦菲", "李现", "胡冰卿", "牛骏峰"],
    region: "中国大陆",
    language: "汉语普通话",
    episodeInfo: "4K·国语中字",
    contentHtml: "<p>《去有风的地方》是由丁梓光执导，刘亦菲、李现领衔主演的田园治愈剧。该剧以云南大理为背景，讲述了许红豆在人生低谷时来到云苗村，逐渐找回自我的故事。</p><p>许红豆因为最好闺蜜的突然离世而陷入了深深的悲伤和迷茫。她独自前往大理云苗村的\"有风小院\"，希望在这个远离城市喧嚣的地方找到内心的平静。在那里，她遇到了谢之遥——一个放弃了高薪工作，回到家乡创业的年轻人。</p><p>剧集以优美的自然风光和舒缓的生活节奏为基础，展现了当代年轻人在城市与乡村之间的选择与挣扎。刘亦菲和李现的演绎自然真挚，加上大理如画的风景，使该剧成为了一部让观众\"看完就想辞职去旅行\"的治愈系佳作。</p>",
    relatedVideos: ["v010", "v013", "v017"]
  }
];

export const categories: string[] = [
  "全部",
  "热播剧集",
  "科幻大片",
  "动作大片",
  "奇幻巨制",
  "高分佳作"
];

export const featuredIds: string[] = ["v009", "v015", "v008", "v002", "v001", "v005"];

export const latestIds: string[] = ["v008", "v009", "v015", "v002", "v001", "v005", "v003", "v017"];